import * as React from "react";
import { Grid, GridColumn, GridDetailRow } from "@progress/kendo-react-grid";

class CarrierContactInfo extends GridDetailRow {
  constructor() {
    super();
    this.state = {
      tableData: [],
    };
  }

  componentDidMount() {
    this.setState({
      tableData: this.props.dataItem.carierInfoData,
    });
  }

  selectionChange(event) {
    
    const data = this.state.tableData.map((item) => {
      if (item.contactEmail === event.dataItem.contactEmail) {
        item.selected = !event.dataItem.selected;
        item.carrierId = this.props.dataItem.carrierId;
        this.props.dataItem.changeExpandedCarrierChildsSelected(item);
      }
      return item;
    });
    this.setState({ tableData: data });
  }

  headerSelectionChange(event) {
    const checked = event.syntheticEvent.target.checked;
    const data = this.state.tableData.map((item) => {
      item.selected = checked;
      item.carrierId = this.props.dataItem.carrierId;
      this.props.dataItem.changeExpandedCarrierChildsSelected(item);
      return item;
    });
    this.setState({ tableData: data });
  }

  render() {
    return (
      <div>
        <Grid
          ScrollMode="scrollable"
          style={{ height: "600px", width: 'auto'}}
          data={this.state.tableData}
          selectedField="selected"
          onSelectionChange={this.selectionChange.bind(this)}
          onHeaderSelectionChange={this.headerSelectionChange.bind(this)}
        >
          <GridColumn field="selected" width="50px"></GridColumn>
          <GridColumn field="geo" title="Geo"></GridColumn>
          <GridColumn field="country" title="Country"></GridColumn>
          <GridColumn field="modeTransport" title="Mode"></GridColumn>
          <GridColumn field="segment" title="Segment"></GridColumn>
          <GridColumn field="scacd" title="Carrier"></GridColumn>
          <GridColumn field="contactName" title="ContactName"></GridColumn>
          <GridColumn field="contactEmail" title="Contact Email"></GridColumn>
        </Grid>
      </div>
    );
  }
}

export default CarrierContactInfo;
